module.exports = __webpack_public_path__ + "static/media/featureHealthy_illust.c699a57d.jpg";